import React, { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

/**
 * Bounty completion celebration popup with confetti.
 * @param {boolean} open
 * @param {{ title?: string, rewardAmount?: number, rewardType?: string }} bounty
 * @param {() => void} onClose
 */
export default function BountyCompletionModal({ open, bounty, onClose }) {
  useEffect(() => {
    if (!open || !bounty) return;
    const t = setTimeout(() => {
      const root = document.getElementById("confetti-root") || (() => {
        const el = document.createElement("div");
        el.id = "confetti-root";
        el.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:9999;";
        document.body.appendChild(el);
        return el;
      })();
      const colors = ["#5e72e4", "#2dce89", "#fb6340", "#11cdef", "#ffc107", "#8b6914"];
      const angle = (i) => (i / 50) * 2 * Math.PI;
      for (let i = 0; i < 50; i++) {
        const d = document.createElement("div");
        const dist = 100 + Math.random() * 100;
        const x = Math.cos(angle(i)) * dist;
        const y = Math.sin(angle(i)) * dist;
        d.style.cssText = `
          position:absolute;left:50%;top:50%;width:8px;height:8px;
          background:${colors[i % colors.length]};
          border-radius:50%;
          animation:bounty-confetti-${i} 1.8s ease-out forwards;
        `;
        const style = document.createElement("style");
        style.textContent = `@keyframes bounty-confetti-${i}{to{transform:translate(${x}px,${y}px) scale(0);opacity:0;}}`;
        document.head.appendChild(style);
        root.appendChild(d);
        setTimeout(() => { d.remove(); style.remove(); }, 2000);
      }
    }, 300);
    return () => clearTimeout(t);
  }, [open, bounty]);

  if (!bounty) return null;

  const title = bounty.name || bounty.title;
  const rewardValue = bounty.reward_value ?? bounty.rewardAmount ?? 0;
  const rewardType = bounty.reward_type || bounty.rewardType || "Cash";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogContent sx={{ textAlign: "center", py: 4 }}>
        <Box sx={{ color: "primary.main", mb: 2 }}>
          <EmojiEventsIcon sx={{ fontSize: 56 }} />
        </Box>
        <Typography variant="h6" fontWeight={700} gutterBottom sx={{ letterSpacing: "0.08em" }}>
          🎉 Bounty Completed!
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          You completed:
        </Typography>
        <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Reward earned:
        </Typography>
        <Typography variant="h6" color="success.main" fontWeight={700}>
          ${rewardValue} {rewardType}
        </Typography>
        <Button variant="contained" onClick={onClose} sx={{ mt: 3 }}>
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
}
